import React, { useState, useRef } from 'react';
import { List, Datagrid, TextField, FunctionField, SimpleList, useRefresh, useRedirect, Create, Edit, TextInput, SimpleForm, Toolbar, SaveButton, EditButton, SelectInput, AutocompleteArrayInput, FormDataConsumer, CheckboxGroupInput } from 'react-admin';
import { vehicleSvgs, hideName, hideVehicleNumber } from "./sharedData";
import { useMediaQuery, Avatar, withStyles, makeStyles, IconButton, Dialog, ListItem, ListItemIcon, ListItemText, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import CustomFilter from './components/CustomFilter';
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import RaAutocompleteInput from './components/RaAutocompleteInput';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import moment from 'moment';
import CustomExportButton from './components/CustomExportButton';
import queryString from 'query-string';
import config from "./config.json";
import ParkingSearchSelector from './components/ParkingSearchSelector';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import CustomCreateButton from './components/CustomCreateButton';

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};
const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    }
});


const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 48 }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);

// const renderBrand = row => row.brand ? row.brand : '-'
// const renderModel = row => row.model ? row.model : '-'
// const renderAmount = (row, fieldName) => (`₹ ${parseFloat(row[fieldName])}`);
function ParkingArrayField(props) {
    const { record, source } = props;

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    if (typeof record[source] !== "string")
        return null;

    const parkings = record[source].split("|");

    return (
        <div style={{ textAlign: "left", display: "block", alignItems: "center", flex: 1 }}>
            <IconButton style={{ width: 40, height: 40, fontSize: 16, color: customTheme.palette.secondary.main }} onClick={openDialog}>{parkings.length}</IconButton>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog} PaperProps={{ style: { maxWidth: 400 } }}>
                {parkings.map(parking => (
                    <ListItem>
                        <ListItemIcon><DirectionsCarIcon /></ListItemIcon>
                        <ListItemText primary={parking.split(':')[0].trim()} />
                    </ListItem>
                ))}
            </Dialog>
        </div>
    );
}

const CATEGORY = "VIP VEHICLES SECTION"
export const ExemptedVehicles = (props) => {
    const eventTracker = UseAnalyticsEvent()

    const classes = useStyles()
    const refresh = useRefresh()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    const listDataRef = useRef();

    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "Tag Number"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");

    let filterTypesInitState = [
        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        }
    ]
    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/exemptedVehicles?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "Exempted Vehicles"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    React.useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {

            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }

            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, " VIP VEHICLES LIST")
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: isSmallDevice ? "0px" : "0 0 10px" }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
                <CustomCreateButton label="Create" basePath={props.basePath} resource={props.resource} />
                <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
            </div>

            <List {...props}
                style={{marginTop: 20}}
                empty={false}
                title="Exempted Vehicles"
                filter={filter}
                bulkActionButtons={false}
                exporter={false}
                actions={false}
                pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}}/>}>

                {isSmallDevice ?
                    <SimpleList
                        leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow:"visible" }} />}
                        primaryText={record => hideVehicleNumber(record.vehicle_number.toUpperCase())}
                        secondaryText={record => (<div>
                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <div style={{ color: "#5a5a5a" }}>Parkings:</div>
                                <ParkingArrayField {...props} record={record} source="vehicle_parkings" label="Parkings" />
                            </div>
                            {record.tag_number && <div><span style={{ color: "#5a5a5a" }}>Tag NUmber: </span>{record["tag_number"]}</div>}
                            {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Created On: </span>{renderTime(record["created_on"])}</div>}
                            {record.updated_on && <div><span style={{ color: "#5a5a5a" }}>Updated On: </span>{renderTime(record["updated_on"])}</div>}
                        </div>)}
                        rightIcon={record => {!viewOnly && <> <EditButton {...props} record={record} />  <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/exemptedVehicles'} /> </>}}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid className={!viewOnly ? 'exemptedVehiclesDataGrid' : ''} component={ScrollableTable}>
                        <FunctionField
                            source="vehicle_type"
                            label="Type"
                            render={renderVehicleType}
                            sortable
                        />
                        <FunctionField source="name" label="Name" render={record => record && record["name"] !== null ? hideName(record["name"]) : "-"} />
                        <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record["vehicle_number"] !== null ? hideVehicleNumber(record["vehicle_number"]) : "-"} />
                        <TextField source="tag_number" label="Tag Number" />
                        <ParkingArrayField source="vehicle_parkings" label="Parkings" />
                        <FunctionField source="created_on" label="Created On" render={record => renderTime(record["created_on"])} />
                        <FunctionField source="updated_on" label="Updated On" render={record => renderTime(record["updated_on"])} />

                        {!viewOnly && <FunctionField className="ListIconsContainerExemptedVehicles" render={record => record &&
                            <div className="ListIcons">
                                <div>
                                    <EditButton {...props} title="Edit" label={false} record={record} />
                                </div>
                                <div>
                                    <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/exemptedVehicles'} />
                                </div>
                            </div>
                        } />}
                    </Datagrid>
                }
            </List>
        </div>
    )
};
const permitVehicleTypes = [
    { id: '2', name: '2-Wheeler' },
    { id: '4', name: '4-Wheeler' },
];

const fuelTypes = [
    { id: 'Pertrol', name: 'Petrol' },
    { id: 'Diesel', name: 'Diesel' },
    { id: 'CNG', name: 'CNG' },
];
const transmissionTypes = [
    { id: 'Manual', name: 'Manual' },
    { id: 'Auto', name: 'Auto' },
];

const checkBoxTypes = [
    { id: 'ALL', name: 'Exempt on all Parkings' },
]
const validateVehicleNumber = vehicleNumber => {
    if (vehicleNumber == null || vehicleNumber === "") {
        return "Vehicle Number is Required";
    } else if (vehicleNumber.length > 200) {
        return "Vehicle Number is too long";
    } else if (new RegExp("^[0-9]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    else if (new RegExp("^[a-zA-Z]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    else if (!new RegExp("^[A-Za-z0-9]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    return true;
};

const validateVehicleCreation = (values) => {

    const errors = {};
    const vehicleNumberValidation = validateVehicleNumber(values.vehicle_number);
    if (vehicleNumberValidation !== true) {
        errors.vehicle_number = vehicleNumberValidation;
    }
    if (values.vehicle_type == null || values.vehicle_type === "") {
        errors.vehicle_type = 'Vehicle Type is Required';
    }
    if (values.tag_number == null || values.tag_number === "") {
        errors.tag_number = 'Tag Number is Required';
    }

    return errors;
};
export const CreateExemptedVehicle = (props) => {
    const eventTracker = UseAnalyticsEvent()

    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    React.useEffect(() => {
        eventTracker(CATEGORY, "CREATE VIP VEHICLE")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Create {...props} onFailure={onFailure} onSuccess={onSuccess}>
            <SimpleForm {...props} redirect="list" validate={(values) => validateVehicleCreation(values)} toolbar={<CustomToolbar />}>
                <div>
                    <div className="formLabel-bold">Parking Location</div>


                </div>
                <div style={{ display: "grid", gridTemplateColumns: "20% 20px 20%", marginTop: 8, width: "100%", alignItems: "center", gap: 50 }}>
                    <RaAutocompleteInput multiple={true} source="access_key_id" resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ width: "100%" }} />
                    <div className="formLabel-bold" style={{ fontSize: "25px" }}>OR</div>
                    <CheckboxGroupInput source="exempted_all" choices={checkBoxTypes} />
                </div>

                <div className="formLabel-bold" style={{ marginTop: 5 }}>Vehicle Details</div>
                <div className="grid-250" style={{ marginTop: 8 }}>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Full Name</div>
                        <TextInput source="name" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Vehicle Number*</div>
                        <TextInput format={(value) => value && value.toUpperCase()} source="vehicle_number" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Tag Number</div>
                        <TextInput source="tag_number" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Brand</div>
                        <TextInput source="brand" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Model</div>
                        <TextInput source="model" label="" variant="outlined" style={{ width: "100%" }} />
                    </div>
                </div>

                <div className="grid-250" style={{ marginTop: 8 }}>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Vehicle Type*</div>
                        <SelectInput variant="outlined" label="" source="vehicle_type" choices={permitVehicleTypes} optionText="name" optionValue="id" style={{ display: "flex" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Fuel Type</div>
                        <SelectInput variant="outlined" label="" source="fuel_type" choices={fuelTypes} optionText="name" optionValue="id" style={{ display: "flex" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Transmission Type</div>
                        <SelectInput variant="outlined" label="" source="fuel_transmission" choices={transmissionTypes} optionText="name" optionValue="id" style={{ display: "flex" }} />
                    </div>
                </div>
            </SimpleForm>
        </Create>
    )
};

const CustomToolbar = withStyles(toolbarStyles)(props => (
    <Toolbar {...props}>
        <SaveButton style={{ backgroundColor: "#18cc69", marginTop: 13, width: "120px", borderRadius: 5 }} disableElevation />
    </Toolbar>
));

export const EditExemptedVehicle = (props) => {
    const eventTracker = UseAnalyticsEvent()
    const optionRenderer = choice => `${choice.name}`;

    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    React.useEffect(() => {
        eventTracker(CATEGORY, "EDIT VIP VEHICLE")
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    return (<Edit {...props} onFailure={onFailure} onSuccess={onSuccess}>
        <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
            <div>
                <div className="formLabel-bold">Parking Details</div>
                <div className="formLabel-regular" style={{ marginTop: 15 }}>Add Parkings</div>
                <RaAutocompleteInput source="access_key_ids" multiple={true} resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ marginTop: 5, marginBottom: 25 }} />
            </div>
            <FormDataConsumer>
                {({ formData, ...rest }) => {
                    let result;
                    let newResult;
                    if (formData && formData.vehicle_parkings) {
                        result = formData.vehicle_parkings.split("|")
                        newResult = result.map((val) => {
                            return { id: Number(val.split(':')[1].trim()), name: val }
                        })
                    }
                    return (
                        formData && formData.vehicle_parkings && <AutocompleteArrayInput label="Remove Parkings" choices={newResult} source="remove_access_keys" optionText={optionRenderer} options={{ suggestionsContainerProps: { placement: "bottom-start" } }} variant="outlined" style={{ width: "100%" }} />
                    )
                }}
            </FormDataConsumer>
            <div className="formLabel-bold" style={{ marginTop: 5 }}>Vehicle Details</div>
            <div className="grid-250" style={{ marginTop: 8 }}>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Full Name</div>
                    <TextInput source="name" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Vehicle Number*</div>
                    <TextInput format={(value) => value && value.toUpperCase()} source="vehicle_number" label="" variant="outlined" style={{ width: "100%" }} disabled />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Tag Number</div>
                    <TextInput source="tag_number" label="" variant="outlined" style={{ width: "100%" }} disabled />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Brand</div>
                    <TextInput source="brand" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Model</div>
                    <TextInput source="model" label="" variant="outlined" style={{ width: "100%" }} />
                </div>
            </div>

            <div className="grid-250" style={{ marginTop: 8 }}>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Vehicle Type*</div>
                    <SelectInput variant="outlined" label="" source="vehicle_type" choices={permitVehicleTypes} optionText="name" optionValue="id" style={{ display: "flex" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Fuel Type</div>
                    <SelectInput variant="outlined" label="" source="fuel_type" choices={fuelTypes} optionText="name" optionValue="id" style={{ display: "flex" }} />
                </div>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Transmission Type</div>
                    <SelectInput variant="outlined" label="" source="fuel_transmission" choices={transmissionTypes} optionText="name" optionValue="id" style={{ display: "flex" }} />
                </div>
            </div>

        </SimpleForm>
    </Edit >)
};
